import React, {Component} from 'react'

// import styles
import './carsizemodal.scss'

// import components
import Modal from '../../components/Modal'

// Utils
import { translation } from '../../../utils/helpers'

// Elements
// import Icon from '../../elements/icon'
import Label from '../../elements/label'
import Divider from '../../elements/divider'

import { ModalIcons } from '../../elements/icons'

class CarsizeModal extends Component {

  constructor (props) {
    super(props)
    this.state = {
      overflowHidden: false
    }
  }

  render () {
    return (
      <div className='carsize__modal'>
        <Modal {...this.props} header={translation('251')} overflowHidden={this.state.overflowHidden}
          icon={ModalIcons.Help}>
          <div className='size_wrap'>
            <Label>{translation('1357')}</Label>
            <div className='car_image car-small' />
            <p>C1, Up, Swift, Ka, Fiesta, i10, Picanto, Twingo, Mazda 2</p>
          </div>
          <Divider />
          <div className='size_wrap'>
            <Label>{translation('1288')}</Label>
            <div className='car_image car-medium' />
            <p>Golf, C­max, i20, i30, C4, Fabia, Focus, Ceed, Clio, Mazda 3</p>
          </div>
          <Divider />
          <div className='size_wrap'>
            <Label>{translation('1358')}</Label>
            <div className='car_image car-large' />
            <p>Stationcar, MPV/SUV, VAN, Passat, Mondeo, S-max, i35, C5, i40, Insignia, Scenic, Mazda 5</p>
          </div>
        </Modal>
      </div>
    )
  }

}

export default CarsizeModal



// WEBPACK FOOTER //
// ./src/app/shared/modals/CarsizeModal/index.js